<template >
    <!-- <v-row align="center" justify="center" class="my-4 px-5">
            <v-toolbar class="dark-rounded-header p-0">
                <v-col md="5">
                    <v-toolbar-title class="size-16" style="padding-left: 1.5rem">{{ $t("res_Label_Approver") }}</v-toolbar-title>
                </v-col>
                <v-col md="4">
                    <v-toolbar-title class="size-16">{{ $t("res_Label_Time_Date") }}</v-toolbar-title>
                </v-col>
                <v-col md="3">
                    <v-toolbar-title class="size-16 text-end">{{ $t("res_Label_Status") }}</v-toolbar-title>
                </v-col>
            </v-toolbar>
        </v-row> -->
        <div class="d-flex mx-auto align-items-start">
            <div class="signing-history">
                <v-list-item class="bg-white mt-4"
                    v-for="(item, index) in signingHistory" :key="index" hover>
                    <div class="d-flex flex-row">
                        <div class="position-relative h-100">
                            <div v-if="signingHistory.length > 1  && item.Time.length>1" class="d-flex flex-column align-items-center" style="min-width: 177px;">
                                <v-list-item-title v-if="item.Time != '--'" class="align-self-end main-text-large " 
                                v-text="item.Time + ', ' + utils.dateFormat(item.Date)"></v-list-item-title>

                            <v-list-item-title v-if="item.Time == '--'" class="align-self-end action-label-new"></v-list-item-title>

                            </div>
                        </div>
                        <!-- text next to avatar -->
                        <div class="position-relative">
                            <div v-if="index != Object.keys(signingHistory).length - 1" class="arrow-up-signing"></div>
                            
                            <div class="d-flex align-items-start"> 
                                <div class=" d-flex align-items-start">
                            <v-list-item-avatar  class="mx-3 my-0"> 
                                <v-avatar class="avatar-image signingHistoryAvatar" color="#eff2f5" size="43">{{ CapitalizeFirstLetter(item.name) }}</v-avatar>
                            </v-list-item-avatar>
        
                </div>
                            <!-- <div v-if="index != Object.keys(signingHistory).length - 1" class="light-v-spacer"></div> -->
                            <v-list-item-content class="signing-history-text">
                                <v-list-item-title class="item-name main-text-large" v-text="`${item.name}`"></v-list-item-title>
                                <v-list-item-title class="action-label-new " style="letter-spacing: 0.015">{{ item.profession }}<br/>{{ (item.structureName == '' ? '' : (item.profession == '' ? '' : ', ')+item.structureName) }}{{ (item.companyName == '' ? '' :
                ((item.profession == '' && item.structureName == '') ? '' : ', ') + item.companyName) }}
                                </v-list-item-title> 
                                <v-list-item-title class="action-label-new " style="letter-spacing: 0.015"> 
                                    <span style="font-size: 11px;color: black;font-weight:500">{{item.signatureDateSTR}}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                            <!-- <v-list-item-title v-if="item.Time != '--'" class="text-secondary size-11"
                                v-text="item.Time + ', ' + utils.dateFormat(item.Date)"></v-list-item-title> -->
                            <!-- <v-list-item-title v-if="item.Time == '--'" class="text-secondary size-11">--</v-list-item-title> -->
                        <!-- </div>
                    </div> -->
                    <div class="d-flex">
                        <v-list-item-content>
                            <v-list-item-title   :class="{  text_in_signed: item.status === 'Signed', text_in_pending: item.status === 'Pending', text_in_progress: item.status === 'In Progress'  }"
                            v-text="$t(constants.signStatusEnum.getByKey(item.status).text)"></v-list-item-title>
                </v-list-item-content>
                        <v-icon v-if="item.status === 'Signed'" class="text_in_signed ml-1 mt-1"
                            style="font-size: 18px!important">mdi-check</v-icon>
                    </div>

        </div>

                        <div class=" text-next-arrow">                
                    </div>

        </div>

                    </div>
                </v-list-item>
            </div>
        </div>
</template> 
    <style>
        .signingHistoryAvatar{
            color:black !important;
            cursor:default !important;
        }  
    </style>
<script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import * as utils from '@/assets/js/common.js'

export default {
    name: 'SigningHistory',
    data: function () {
        return {
            signingHistory: [],
            utils: utils,
            constants: constants
        }
    },
    props: {
        documentId: { type: [String, Number], default: '0' },
        dialogModelShow: { type: Boolean, default: false },
    },
    methods:
    {
        getSignatureHistory: function () {
            if (this.documentId == 0)
                return

            axios.all([
                axios.get(constants.baseApiUrl + 'Document/GetSignatureHistory?documentId=' + this.documentId, { headers: this.headers }),
                axios.get(constants.baseApiUrl + 'Document/GetSignatureCountForDocument?documentId=' + this.documentId, { headers: this.headers })
            ])
                .then(axios.spread((response1, response2) => {
                    this.signingHistory = []

                    var templateSignatureCount = response2.data
                    for (var i = 0; i < templateSignatureCount; i++) {
                        this.signingHistory.push({
                            name: this.$t('res_Label_Signer') +' '+ (i + 1),
                            nameAr: this.$t('res_Label_Signer') +  " " + (i + 1),
                            profession: "",
                            professionAr: "",
                            status: "--",
                            Time: "--",
                            Date: "--:-- --",
                            structureName: "",
                            companyName: "",
                            structureNameAr: "",
                            companyNameAr: "",
                        })
                    }
                     
                    var allSignatures = response1.data
                    for (let index = 0; index < allSignatures.length; index++) {
                        const element = allSignatures[index];

                        var name = element.name, nameAr = element.nameAr, profession = element.profession, professionAr = element.professionAr
                        if (element.onBehalfName != null && element.onBehalfName != "") {
                            profession = 'On Behalf Of ' + element.onBehalfName
                        }
                        if (element.onBehalfNameAr != null && element.onBehalfNameAr != "") {
                            professionAr = 'عن /' + element.onBehalfNameAr
                        } 
                        let myobj = {
                            name: window.getLocalizedVal(name, nameAr),
                            nameAr: nameAr,
                            profession:  window.getLocalizedVal(profession,professionAr),
                            professionAr: professionAr,
                            status: element.signatureStatus,
                            Time: (element.signatureDate === '0001-01-01T00:00:00' ? '--' : new Date(element.signatureDate).toLocaleTimeString()),
                            Date: (element.signatureDate === '0001-01-01T00:00:00' ? '--:-- --' : new Date(element.signatureDate).toLocaleDateString()),
                            structureName: window.getLocalizedVal(element.structureName, element.structureNameAr),
                            companyName: window.getLocalizedVal(element.companyName, element.companyNameAr),
                            structureNameAr: element.structureNameAr,
                            companyNameAr: element.companyNameAr,
                            signatureDateSTR: element.signatureDateSTR
                        }

                        this.signingHistory[index] = myobj
                    }

                    for (let index = 0; index < this.signingHistory.length; index++) {
                        if (this.signingHistory[index].status != "Signed") {
                            this.signingHistory[index].status = "In Progress"
                            break
                        }
                    }

                    // reverse the array
                    this.signingHistory.reverse()
                }))
                .catch(err => console.warn(err))
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
    },
    mounted: function () {
        this.getSignatureHistory()
    },
    watch:
    {
        dialogModelShow(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal == true)
                    this.getSignatureHistory()
                else {
                    this.signingHistory = []
                }
            }
        },
        documentId(newVal, oldVal) {
            if (newVal != oldVal) {
                this.getSignatureHistory()
            }
        },
    },
}
</script>